
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

/**
 * Sort Settings Interface
 * Defines an interface for specifying a database name and default direction.
 * Can also include a single level of secondary sorts
 */
export interface SortSettingInterface {
  dbName: string;
  defaultOrder?: SortOrder;
  secondarySort?: {
    dbName: string;
    order?: SortOrder;
  };
}

/**
 * Sort Mapping
 * Typing for valid sort fields and translation to database names
 * The key should be all lowercase
 * The value should either be the database field, or a SortSettingsInterface if you need more control or secondary sorts
 */
export type SortMapping = { [key: string]: SortSettingInterface | string };
